import React, { useState } from 'react';
import axios from 'axios';

const BurgerSelection = () => {
  const [burger, setBurger] = useState({
    name: '',
    drink: [],
    menu: 'withMenu',
    salad: [],
    sauce: [],
    specialInstructions: '',
    price: 0,
  });
console.log(burger)
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      setBurger((prevBurger) => {
        const newValues = checked
          ? [...prevBurger[name], value]
          : prevBurger[name].filter((item) => item !== value);
        return { ...prevBurger, [name]: newValues };
      });
    } else {
      setBurger({ ...burger, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/admin/burger', burger);
      console.log(response.data);  // Successfully added burger
    } catch (error) {
      console.error('Error adding burger', error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>Burger Name</label>
        <input
          type="text"
          name="name"
          value={burger.name}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label>Drink</label>
        <input
          type="checkbox"
          name="drink"
          value="Coke"
          checked={burger.drink.includes('Coke')}
          onChange={handleChange}
        /> Coke
        <input
          type="checkbox"
          name="drink"
          value="Pepsi"
          checked={burger.drink.includes('Pepsi')}
          onChange={handleChange}
        /> Pepsi
      </div>
      <div>
        <label>Menu Option</label>
        <select name="menu" value={burger.menu} onChange={handleChange}>
          <option value="withMenu">With Menu (Fries + Drink)</option>
          <option value="sansMenu">Sans Menu</option>
        </select>
      </div>
      <div>
        <label>Salad</label>
        <input
          type="checkbox"
          name="salad"
          value="Lettuce"
          checked={burger.salad.includes('Lettuce')}
          onChange={handleChange}
        /> Lettuce
        <input
          type="checkbox"
          name="salad"
          value="Tomato"
          checked={burger.salad.includes('Tomato')}
          onChange={handleChange}
        /> Tomato
        <input
          type="checkbox"
          name="salad"
          value="Onions"
          checked={burger.salad.includes('Onions')}
          onChange={handleChange}
        /> Onions
      </div>
      <div>
        <label>Sauce</label>
        <input
          type="checkbox"
          name="sauce"
          value="Ketchup"
          checked={burger.sauce.includes('Ketchup')}
          onChange={handleChange}
        /> Ketchup
        <input
          type="checkbox"
          name="sauce"
          value="Mustard"
          checked={burger.sauce.includes('Mustard')}
          onChange={handleChange}
        /> Mustard
      </div>
      <div>
        <label>Special Instructions</label>
        <textarea
          name="specialInstructions"
          value={burger.specialInstructions}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>Price</label>
        <input
          type="number"
          name="price"
          value={burger.price}
          onChange={handleChange}
          required
        />
      </div>
      <button type="submit">Add Burger</button>
    </form>
  );
};

export default BurgerSelection;
